$('body').on('focus, click', '.select__value', function() {
    var select = $(this).parents('.select'),
        optionsList = select.find('.select__options-list');

    $('.select').find('.select__value').removeClass('focus');
    $('.select__options-list').addClass('hidden');
    $(this).toggleClass('focus');
    optionsList.toggleClass('hidden');
})

$('body').on('click', '.select__option', function() {
    var select = $(this).parents('.select'),
        optionValue = $(this).text(),
        selectValueInput = select.find('input.select__value'),
        selectValueDiv = select.find('div.select__value'),
        optionsList = select.find('.select__options-list'),
        clearSelect = select.find('.select__clear');

    optionsList.find('.select__option').removeClass('select__option_choosen');
    optionsList.addClass('hidden');
    $(this).addClass('select__option_choosen');
    selectValueInput.val(optionValue).removeClass('focus').removeClass('has-error');
    selectValueDiv.text(optionValue).removeClass('focus');
    clearSelect.removeClass('hidden');
})

// закрытие select при клике в любое место
$('body').click(function(event) {
    if($(event.target).parents('.select').length == 0) {
        $('.select__options-list').addClass('hidden');
        $('.select__value').removeClass('focus');
    }
})

// закрытие select при фокусе на любом другом поле
$('body').on('focus', 'input, textarea', function() {
    if (!$(this).hasClass('select__value')) {
        $('.select').find('.select__value').removeClass('focus');
        $('.select__options-list').addClass('hidden');
    }
})

// запрет ввода в селекторе
$('body').on('keypress', 'input[name=location], input[name=school], input[name=school_class]', function () {
    return false;
})